import { createExternalStore } from './createExternalStore';

/**
 * Lead-management client-only state, migrated off Apollo `makeVar` reactive vars.
 * Read reactively via `useValue()`; written imperatively via `set()`.
 */

/**
 * Conversation whose renter profile was just requested. Drives the "Profile requested" state in the
 * screening-criteria cells until the lead-management table refetches.
 */
export const leadManagementShowProfileRequestedForConversationIdStore = createExternalStore('');

/**
 * Signals RenterDetailsModal which section to scroll to on open. The modal resets it to '' once it
 * has scrolled.
 */
export const leadManagementRenterDetailsSectionToScrollToStore = createExternalStore<
  'latestContact' | 'notepad' | 'renterDetailsHeader' | 'renterProfile' | ''
>('');

/**
 * Conversation whose messaging window is minimized to its pill ('' = not minimized). Holds the id
 * rather than a boolean because restore paths must invalidate the *minimized* conversation's
 * messages — realtime updates skip the active conversation, so it's the only one that can go
 * stale — and the window being opened isn't necessarily the one that was minimized. Deliberately
 * not a URL param so shared links never carry someone's minimized state. Reset when the window
 * unmounts (closed) and when a conversation is explicitly opened, so those always present an
 * expanded window.
 */
export const leadManagementMinimizedMessagingConversationIdStore = createExternalStore('');
